import { CardLinkDto } from "./card-link.dto";

export class CardLinkTranslationDto{
    /*
    * 
    */
   constructor(
    public id?:  number,
    public title?: string,
    public distance?: string,
    public minPrice?: number,
    public maxPrice?: number,
    public currency?: string,
    public locale?: string,
    public details?: string,
    public fullAddress?: string,
    public cardLink?: CardLinkDto
   ){}
}